import { ChangeDetectionStrategy, Component, ComponentRef, EventEmitter, Input, Output } from '@angular/core'
import { AdComponentInputs } from 'src/app/shared/ads/ad/ad-component.interface'
import { AdTypes, HasInstance } from 'src/app/shared/ads/advertising-service/ad-config'
import {
  FilterablePartial,
  EntityHubLayout,
  LinkModel,
  MessageModel,
  GridContainerPartial,
  VideoPlayerCard,
  ContainerPartial,
  ImageWithButtonsModel,
  FilterableGridPartial,
  FilterOptionModel
} from '@flocasts/experience-service-types'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'
import { AdComponent } from 'src/app/shared/ads/ad/ad.component'

/**
 * Two column layout used for entity hubs and event hubs.
 */
@Component({
  selector: 'flo-entity-hub-layout',
  templateUrl: './entity-hub-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EntityHubLayoutComponent {
  @Input() layout: EntityHubLayout
  @Input() partial: FilterablePartial | FilterableGridPartial | GridContainerPartial | ContainerPartial | undefined
  @Input() public imageWithButtons: ImageWithButtonsModel | null
  @Input() public description: string | undefined | null
  @Input() public geoBlockedIds: ReadonlyArray<number>
  @Input() public selectedTab: LinkModel | undefined
  @Input() isLoading: boolean
  @Input() isPartialError: boolean
  @Input() hideRightRail: boolean
  @Input() message: MessageModel | undefined
  @Input() public adConfigMap: Map<AdTypes, AdComponentInputs>
  @Input() selectedItem: VideoPlayerCard | undefined
  @Output() layoutHeaderCtaButton = new EventEmitter<LinkModel>()
  @Output() nextPage = new EventEmitter<string>()
  @Output() tabClicked = new EventEmitter<LinkModel>()
  @Output() toggleClicked = new EventEmitter<FilterOptionModel>()
  @Output() public lazyLoadedAdRef = new EventEmitter<HasInstance<AdComponent>>()

  trackById = trackById

  public handleNextPage(url: string) {
    this.nextPage.emit(url)
  }

  public readonly loadedAdsPush = (loadedAd: ComponentRef<AdComponent>): void => {
    this.lazyLoadedAdRef.next(loadedAd)
  }

  public handleTabClicked(link: LinkModel) {
    this.tabClicked.emit(link)
  }

  public handleToggleClicked(toggleOption: FilterOptionModel) {
    this.toggleClicked.emit(toggleOption)
  }

  public AdComponent = import('src/app/shared/ads/ad/ad.component').then(m => m.AdComponent)

  handleHeaderCtaButtonClick(link: LinkModel) {
    this.layoutHeaderCtaButton.emit(link)
  }
}
